import React, { useState, useEffect, useRef } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Col, Container, Row, Tab } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import Table from 'react-bootstrap/Table';
import Laoding from '../shared/Laoding';
import ShowError from "../shared/ShowError";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import * as parameterHelper from '../shared/extraParameterHelper';
import axios from "axios";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";
import { AutoComplete } from 'primereact/autocomplete';

export default function AllProducts(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [products, setProducts] = useState([]);
    const [searchParams] = useSearchParams();
    const software = searchParams.get("software");

    useEffect(() => {
        var sn = software;
        
        if(sn == "ALlTaxService") sn = "TaxService";
        else if(sn == "AllSalaryCertificate") sn = "SalaryCertificate";
        else if(sn == "AllLoanCenter") sn = "AllLoanCenter";
        var ps = [
            {
                caption:"حسابداری هانا",
                packages:[
                    {
                        "code": "SimpleWinAccounting",
                        "title": "نسخه حسابداری ساده",
                        "link":"product/win-accounting",
                        "price":30000000,
                    },
                    {
                        "code": "ServiceWinAccounting",
                        "title": "نسخه حسابداری خدماتی",
                        "link":"product/win-accounting",
                        "price":87000000,
                    },
                    {
                        "code": "BusinesseWinAccounting",
                        "title": "نسخه حسابداری فروشگاهی/بازرگانی",
                        "link":"product/win-accounting",
                        "price":100000000,
                    },
                    {
                        "code": "VisitoryWinAccounting",
                        "title": "نسخه ویزیتوری (پخش سرد و گرم )",
                        "link":"product/win-accounting",
                        "price":230000000,
                    },
                    {
                        "code": "BarFrooshiWinAccounting",
                        "title": "نسخه میادین میوه و تره بار (بار فروشی)",
                        "link":"product/win-accounting",
                        "price":487000000,
                    },
                    {
                        "code": "ResturantWinAccounting",
                        "title": "نسخه رستوران و اغذیه فروشی",
                        "link":"product/win-accounting",
                        "price":137000000,
                    },
                    {
                        "code": "WorkersWinAccounting",
                        "title": "نسخه خدمات تامین نیرو",
                        "link":"product/win-accounting",
                        "price":147000000,
                    },
                    {
                        "code": "ProductWinAccounting",
                        "title": "حسابداری هانا نسخه تولیدی",
                        "link":"product/win-accounting",
                        "price":300000000,
                    }
                ]
            },
            {
                caption:"حسابداری و مدیریت مالی مدارس",
                packages:[
                    {
                        "code": "independent_school",
                        "title": "حسابداری و مدیریت مالی مدارس مستقل غیر دولتی",
                        "link":"product/school-accounting",
                        "price":80000000,
                    },
                    {
                        "code": "complex_school",
                        "title": "حسابداری و مدیریت مالی مجتمع های آموزشی غیر دولتی",
                        "link":"product/school-accounting",
                        "price":140000000,
                    },
                ]
            },
            {
                caption:"ارسال صورتحساب به سامانه مودیان مالیاتی",
                packages:[
                    {
                        "code": "TaxService",
                        "title": "ارسال صورتحساب به سامانه مودیان مالیاتی",
                        "link":"product/tax-service",
                        "price":26000000,
                    },
                ]
            },
            {
                caption:"صندوقهای وام قرض الحسنه و اعتبار",
                packages:[
                    {
                        "code": "AllLoanCenter",
                        "title": "صندوقهای وام قرض الحسنه و اعتبار",
                        "link":"product/loan-center",
                        "price":350000000,
                    },
                ]
            },
            {
                caption:"سامانه صدور گواهی کسر حقوق کارکنان",
                packages:[
                    {
                        "code": "SalaryCertificate",
                        "title": "سامانه صدور گواهی کسر حقوق کارکنان",
                        "link":"product/salary-certificate",
                        "price":200000000,
                    },
                ]
            },
        ];
        setProducts(ps);
        for(var i=0;i<ps.length;i++){
            for(var j=0;j<ps[i].packages.length;j++){
                if(ps[i].packages[j].code == sn){
                    console.log("code is>", "/" + ps[i].packages[j].code);
                    console.log("link is>", "/" + ps[i].packages[j].link);
                    navigate("/" + ps[i].packages[j].link+"?software=" + sn);
                }
            }
        }
    }, []);
    const getProposeUrl = (code)=>{
        var baseUrl = "Https://Hana.co.ir";
        if(code == "SimpleWinAccounting") return baseUrl + "/" + "نرم-افزار-حسابداری-ساده/";
        if(code == "ServiceWinAccounting") return baseUrl + "/" + "نرم-افزار-حسابداری-خدماتی/";
        if(code == "BusinesseWinAccounting") return baseUrl + "/" + "نرم-افزار-حسابداری-فروشگاهی/";
        if(code == "VisitoryWinAccounting") return baseUrl + "/" + "نرم-افزار-حسابداری-ویزیتوری/";
        if(code == "BarFrooshiWinAccounting") return baseUrl + "/" + "نرم-افزار-حسابداری-میوه-و-تره-بار/";
        if(code == "ResturantWinAccounting") return baseUrl + "/" + "نرم-افزار-حسابداری-رستوران/";
        if(code == "ProductWinAccounting") return baseUrl + "/" + "نرم-افزار-حسابداری-تولیدی/";
        if(code == "WorkersWinAccounting") return baseUrl + "/" + "";
        if(code == "independent_school") return baseUrl + "/" + "نرم-افزار-حسابداری-مدارس/";
        if(code == "complex_school") return baseUrl + "/" + "نرم-افزار-حسابداری-مجتمع-های-آموزشی/";
        if(code == "TaxService") return baseUrl + "/" + "ارسال-صورتحساب-سامانه-مودیان-مالیاتی/";
        if(code == "AllLoanCenter") return baseUrl + "/" + "نرم-افزار-مالی-صندوق-های-قرض-الحسنه/";
        if(code == "SalaryCertificate") return baseUrl + "/" + "سامانه-مدیریت-گواهی-کسر-حقوق-و-تعهدات/";

        return baseUrl;
    }
    return (
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :        
        <>
            <Row style={{margin:"30px 0px", padding:"0px 0px 0px 0px", position:"relative"}}>
            {
                products.map((pg, pgInd)=>{
                    return(
                        <>
                            {
                                pg.packages.map((p, pInd)=>{
                                    return(
                                        <Col md="2">
                                            <div style={{margin:"20px 1px", boxSizing:"border-box", borderRadius:"10px", border:"1px solid #b0b0b0", textAlign:"center"}}>
                                                <table style={{width:"calc(100% - 0px)", margin:"0px auto", borderCollapse:"collapse"}}>
                                                    <tbody>
                                                        <tr><td colSpan={2} style={{textAlign:"center"}}><img onClick={()=>navigate(getProposeUrl(p.code),{})} src={require('../lib/products/webp/'+p.code+'.webp')} style={{borderRadius:"10px 10px 0px 0px", cursor:"pointer", width:"calc(100% - 0px)"}} alt={p.title}/></td></tr>
                                                        <tr><td colSpan={2} style={{textAlign:"center", height:"65px"}}><span onClick={()=>navigate(getProposeUrl(p.code),{})} style={{cursor:"pointer"}}>{p.title}</span></td></tr>
                                                        <tr><td colSpan={2} style={{textAlign:"center",fontSize:"12pt", fontWeight:"bold",padding:"10px 0px 10px 0px"}}>{util.SeperatePrice(p.price)} ریال</td></tr>
                                                        <tr>
                                                            <td style={{width:"50%"}}>
                                                                <div onClick={()=>navigate( getProposeUrl(p.code),{})} style={{backgroundColor:"rgba(189, 189, 196, 0.34)", color:"#272729", textAlign:"center", width:"calc(100% - 0px)", padding:"10px", cursor:"pointer", fontSize:"11pt", fontWeight:"bold", borderRadius:"0px 0px 10px 0px"}}>
                                                                    شرح
                                                                </div>
                                                            </td>
                                                            <td style={{width:"50%"}}>
                                                                <div onClick={()=>navigate(config.Client+"/"+p.link+"?software=" + p.code,{})} style={{backgroundColor:"rgba(248, 135, 140, 0.34)", color:"#bb0817", textAlign:"center", width:"calc(100% - 0px)", padding:"10px", cursor:"pointer", fontSize:"11pt", fontWeight:"bold", borderRadius:"0px 0px 0px 10px"}}>
                                                                    خرید
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                            
                                        </Col>
                                    )
                                })
                            }
                        </>
                    )
                })
            }
            </Row>
        </>

    )
}
